import * as React from "react";
import { Form } from "react-bootstrap";
import {
    Account, DriveWatchedMessages, NotificationFrequencyType, NotificationFrequencyTypes, useEmailFrequency, NotificationFrequencyTypeMap
} from "src/common";
import { InfoPopover } from "src/components";
import _ from "lodash";

type AllProps = {
    current_account: Account;
}

function EmailFrequencyFormComponent({ current_account }: AllProps) {
    const { frequency, loading, setEmailFrequency } = useEmailFrequency(current_account);

    return <Form className="email-frequency">
        <Form.Label>
            Select Email Frequency
            <InfoPopover message={DriveWatchedMessages.email_frequency_info} placement="bottom-end" />
        </Form.Label>
        {
            _.map(NotificationFrequencyType, (_frequency: NotificationFrequencyTypes) => {
                return <Form.Check
                    key={`frequency_${_frequency}`}
                    inline
                    type="radio"
                    id={`frequency_${_frequency}`}
                    name="frequency"
                    label={_frequency}
                    checked={frequency === _frequency}
                    disabled={loading}
                    onChange={() => setEmailFrequency(NotificationFrequencyTypeMap[_frequency])} />;
            })
        }
    </Form>;
}

export default React.memo(EmailFrequencyFormComponent);